<script setup lang="ts">
import { inject, type Ref } from 'vue'
import type { Container } from '@/models/Container'
import Heading from './Heading.vue'

const container = inject('container') as Ref<Container | null>
</script>

<template>
  <Heading>
    <h2>Bac n°{{ container?.code }}</h2>
  </Heading>
</template>
